module.exports = __webpack_public_path__ + "5fc938765b70b6508c4916fae74c74de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/epic-migration/epic.png
// module id = 2892
// module chunks = 0